import { apiClient } from '@/lib/api/apiClient';
import { endpoints } from '@/lib/api/apiEndpoints';

export interface CreateRoomRequest {
  categoryId?: string;
  maxPlayers?: number;
}

export interface CreateRoomResponse {
  roomCode: string;
  roomId: string;
}

export const gameService = {
  async createRoom(data: CreateRoomRequest): Promise<CreateRoomResponse> {
    const response = await apiClient.post<CreateRoomResponse>(
      endpoints.game.createRoom(),
      data
    );
    return response.data;
  },

  async joinRoom(roomCode: string): Promise<void> {
    await apiClient.post(endpoints.game.joinRoom(roomCode));
  },

  async getRoom(roomCode: string): Promise<any> {
    const response = await apiClient.get(endpoints.game.getRoom(roomCode));
    return response.data;
  },
};
